
import React from "react";
import ErrorBoundary from "./config/configureBugsnag";
import * as serviceWorker from "./serviceWorker";
import { HashRouter } from "react-router-dom";
import "./assets/base.scss";
import Main from "./Pages/Main";
import configureStore from './config/configureStore';
import InitReduxState from './services/InitReduxState';
import { createRoot } from 'react-dom/client';
import {Provider} from "react-redux";
import { tippy } from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SWRConfig } from 'swr';
import { swrConfig } from './services/swrConfig';
import { BreadcrumbProvider } from "Layout/AppBreadcrumb/BreadcrumbContext";


if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

tippy.setDefaultProps({
  className: 'custom-tooltip',
  arrow: true,
  appendTo: () => document.body
});

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
const queryClient = new QueryClient();

InitReduxState.InitUserState(configureStore);

const renderApp = (Component) => {
    root.render(
            <SWRConfig value={swrConfig}>
                <Provider store={configureStore}>
                    <QueryClientProvider client={queryClient}>
                        <HashRouter>
                              <BreadcrumbProvider>
                            { process.env.REACT_APP_DISABLE_BUGSNAG === '1'
                             ? 
                             <Component/>
                            : 
                            <ErrorBoundary>
                                <Component/>
                            </ErrorBoundary>
                            }
                            </BreadcrumbProvider>
                        </HashRouter>
                    </QueryClientProvider>
                </Provider>
            </SWRConfig>
    );
};

renderApp(Main);

if (module.hot) {
  module.hot.accept("./Pages/Main", () => {
    const NextApp = require("./Pages/Main").default;
    renderApp(NextApp);
  });
}
serviceWorker.unregister();
